import React from 'react'
import {
  Col, Upload, Row, Input, Checkbox, Select,
} from 'antd'
import * as UI from 'konsys-ui'
import _ from 'lodash'
import moment from 'moment'
import { detailMode } from '../constants'
import { DatePicker } from '../styled'
import { checkFloat } from '../../../utils/util-services'
import { UploadWithModal } from '../../../components/common'

/*
date.type is type of component
0: InputWithLabel
1: input
2: Text (P)
3: Dropdown (Select)
4: Upload box
5: Select
6: TextArea
7: Upload
*/

const CreateMode = ({ data, onChangeHandler, skillData }) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.InputWithLabel
            {...data.props}
            width='100%'
            input={{
              onChange: e => onChangeHandler(data.id, e.target.value),
              onKeyDown: (e) => {
                if (data.id === 'salary' && !checkFloat(e)) {
                  e.preventDefault()
                }
              },
              type: data.id === 'salary' ? 'number' : 'text',
              step: data.id === 'salary' ? '0.1' : undefined,
              min: '0',
              ...data.props.input,
            }}
          />
        </Col>
      )
    case 1:
      return <UI.Input {...data.props} />
    case 2:
      return <UI.P {...data.props}>{data.label}</UI.P>
    case 3:
      return <UI.Select dropdown buttonProps={{ style: { height: '34px', padding: '4px 24px' }, text: data.children[0].text }} data={data.children} {...data.props} />
    case 4:
      return (
        <Col span={data.span} offset={data.offset}>
          <UploadWithModal
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => v.originFileObj))}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    case 5:
      return (
        <Col
          span={data.span}
          style={{}}
        >
          <UI.Div display='flex' flexDirection='column' margin='0'>
            <UI.P margin='8px 0 16px'>{data.label}</UI.P>
            <Checkbox.Group style={{ width: '100%' }} onChange={e => onChangeHandler(data.id, e)}>
            <Row>
            {
              _.map(skillData, v => (
                <Col span={6} style={{ margin: '8px 0' }}><Checkbox value={v.id}><UI.P>{v.name}</UI.P></Checkbox></Col>
              ))
            }
            </Row>
            </Checkbox.Group>
          </UI.Div>
        </Col>
      )
    case 6:
      return <Col
          span={data.span}
          style={{ alignSelf: 'flex-end' }}
        >
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='0 0 16px'>{data.label}</UI.P>
            <Input.TextArea {...data.props} onChange={e => onChangeHandler(data.id, e.target.value)}/>
          </UI.Div>
        </Col>
    case 7:
      return (
        <Col span={data.span}>
          <UploadWithModal
            onChange={(e) => {
              onChangeHandler(data.id, e.fileList.map(v => v.originFileObj))
            }
            }
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    case 8:
      return (
        <Col
          span={data.span}
          offset={data.offset}
          style={{ alignSelf: 'flex-end' }}
        >
          <UI.P>{data.props.title.text}</UI.P>
          <DatePicker onChange={e => onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))} {...data.props}/>
        </Col>
      )
    case 9:
      return (
        <Col
          span={data.span}
          offset={data.offset}
          style={{ alignSelf: 'flex-end' }}
        >
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='8px 0 16px'>{data.props.title.text}</UI.P>
            <Select
              width='100%'
              onChange={e => onChangeHandler('companyType', e)}
            >
              <Select.Option value='PADOONGRICH'>บริษัท ผดุงฤทธิ์ขนส่ง จำกัด</Select.Option>
              <Select.Option value='TRANSPORT'>บริษัท ทรานสปอร์ตเตชั่น เน็ตเวิร์ค จำกัด</Select.Option>
            </Select>
          </UI.Div>
        </Col>
      )
    default:
      return <p>No type</p>
  }
}

const EditMode = ({
  data, disabled, initialData, onChangeHandler, skillData,
}) => {
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.InputWithLabel width='100%' {...data.props} input={{
            disabled,
            defaultValue: initialData[data.id],
            onChange: e => onChangeHandler(data.id, e.target.value),
            onKeyDown: (e) => {
              if (data.id === 'salary' && !checkFloat(e)) {
                e.preventDefault()
              }
            },
            type: data.id === 'salary' ? 'number' : 'text',
            step: data.id === 'salary' ? '0.1' : undefined,
            min: '0',
            ...data.props.input,
          }} />
        </Col>
      )
    case 1:
      return <UI.Input disabled={disabled} {...data.props} defaultValue={initialData[data.id]} onChange={e => onChangeHandler(data.id, e.target.value)} />
    case 2:
      return <UI.P {...data.props}>{data.label}</UI.P>
    case 3:
      return (
        <UI.Select
          dropdown
          buttonProps={{ style: { height: '34px', padding: '4px 24px' }, text: initialData[data.id] }}
          data={data.children}
          disabled={disabled} {...data.props}
        />
      )
    case 4:
      return (
        <Col span={data.span} offset={data.offset}>
          <UploadWithModal
            disabled={disabled}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            defaultFileList={initialData[data.id].map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    case 5:
      return (
        <Col
          span={data.span}
          style={{}}
        >
          <UI.Div display='flex' flexDirection='column' margin='0'>
            <UI.P margin='8px 0 16px'>{data.label}</UI.P>
            <Checkbox.Group
              style={{ width: '100%' }}
              disabled={disabled}
              defaultValue={_.map(initialData.skills, w => w.id)}
              onChange={e => onChangeHandler(data.id, e)}
            >
            <Row>
            {
              _.map(skillData, v => (
                <Col span={6} style={{ margin: '8px 0' }}>
                  <Checkbox value={v.id}>
                    <UI.P>{v.name}</UI.P>
                  </Checkbox>
                </Col>
              ))
            }
            </Row>
            </Checkbox.Group>
          </UI.Div>
        </Col>
      )
    case 6:
      return <Col
        span={data.span}
        style={{ alignSelf: 'flex-end' }}
      >
        <UI.Div display='flex' flexDirection='column'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <Input.TextArea disabled={disabled} {...data.props} defaultValue={initialData[data.id]} onChange={e => onChangeHandler(data.id, e.target.value)}/>
        </UI.Div>
      </Col>
    case 7:
      return (
        <Col span={data.span}>
          <UploadWithModal
            disabled={disabled}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            showUploadList={{
              showRemoveIcon: !disabled,
            }}
            defaultFileList={!_.isNull(initialData[data.id]) && initialData[data.id].map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            onChange={(e) => {
              onChangeHandler(data.id, e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))
            }}
            listType='picture'
            button={data.props}
          />
        </Col>
      )
    case 8:
      return (
        <Col
          span={data.span}
          offset={data.offset}
          style={{ alignSelf: 'flex-end', marginTop: 8 }}
        >
          <UI.P>{data.props.title.text}</UI.P>
          <DatePicker
            onChange={e => onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))}
            disabled={disabled}
            defaultValue={_.isNull(initialData[data.id]) ? initialData[data.id] : moment(initialData[data.id])}
            {...data.props}
          />
        </Col>
      )
    case 9:
      return (
        <Col
          span={data.span}
          offset={data.offset}
          style={{ alignSelf: 'flex-end' }}
        >
          <UI.Div display='flex' flexDirection='column'>
            <UI.P margin='8px 0 16px'>{data.props.title.text}</UI.P>
            <Select
              width='100%'
              disabled={true}
              defaultValue={initialData?.companyType}
              onChange={e => onChangeHandler('companyType', e)}
            >
              <Select.Option value='PADOONGRICH'>บริษัท ผดุงฤทธิ์ขนส่ง จำกัด</Select.Option>
              <Select.Option value='TRANSPORT'>บริษัท ทรานสปอร์ตเตชั่น เน็ตเวิร์ค จำกัด</Select.Option>
            </Select>
          </UI.Div>
        </Col>
      )
    default:
      return <p>no type</p>
  }
}

export default ({
  data, mode, onChangeHandler, initialData, skillData,
}) => {
  switch (mode) {
    case detailMode.ADD:
      return <CreateMode data={data} skillData={skillData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    case detailMode.EDIT:
      return <EditMode data={data} skillData={skillData} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    case detailMode.VIEW:
      return <EditMode data={data} skillData={skillData} disabled={true} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)}/>
    default:
      return <p>no mode</p>
  }
}
